import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import Icon from "@/components/Icon";
import Logo from "@/components/Logo";

export default function Footer() {
  const { content } = useContent();
  const f = content?.footer || {};
  const c = content?.contact || {};

  return (
    <footer
      className="text-white"
      style={{ background: "linear-gradient(180deg,#061544 0%,#0a1f5c 100%)" }}
      data-testid="sp-footer"
    >
      <div className="sp-container py-12 border-b border-white/10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <h3 className="text-3xl lg:text-4xl font-extrabold text-white">
              Have an Idea? <span className="text-gold">Let's Build It.</span>
            </h3>
            <p className="text-white/75 mt-2 max-w-xl">
              We turn bold ideas into scalable digital products and intelligent business systems.
            </p>
          </div>
          <Link to="/contact" className="sp-btn-gold" data-testid="footer-cta-consultation">
            Schedule a Consultation <Icon name="ArrowRight" size={18} />
          </Link>
        </div>
      </div>

      <div className="sp-container py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo variant="dark" />
          <p className="text-white/70 mt-4 text-sm leading-relaxed">
            {f.tagline || "Building AI-powered platforms, digital products and intelligent solutions for Africa."}
          </p>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold tracking-[0.18em] uppercase mb-4">Explore</h4>
          <ul className="space-y-2 text-white/75 text-sm">
            <li><Link to="/" className="hover:text-white" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/products" className="hover:text-white" data-testid="footer-link-products">Products</Link></li>
            <li><Link to="/solutions" className="hover:text-white" data-testid="footer-link-solutions">Solutions</Link></li>
            <li><Link to="/why-us" className="hover:text-white" data-testid="footer-link-why">Why SiliconPay</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold tracking-[0.18em] uppercase mb-4">We Serve</h4>
          <ul className="space-y-2 text-white/75 text-sm">
            <li>Startups</li>
            <li>Enterprises</li>
            <li>Governments</li>
            <li>Across Africa</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold tracking-[0.18em] uppercase mb-4">Let's Talk</h4>
          <ul className="space-y-3 text-white/85 text-sm">
            <li className="flex items-start gap-3">
              <Icon name="Phone" size={16} className="mt-1 text-gold" />
              <a href={`tel:${(f.phone_dial || c.phone_dial || "").replace(/\s+/g, "")}`} className="hover:text-white" data-testid="footer-phone">
                {f.phone || c.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Icon name="Mail" size={16} className="mt-1 text-gold" />
              <a href={`mailto:${f.email || c.email}`} className="hover:text-white" data-testid="footer-email">
                {f.email || c.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Icon name="MapPin" size={16} className="mt-1 text-gold" />
              <span>{f.location || "Lagos, Nigeria · Serving Africa"}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="sp-container py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} SiliconPay Technologies. All rights reserved.</div>
          <div className="italic">{f.footer_quote || "Your vision. Our technology. Limitless impact for Africa."}</div>
        </div>
      </div>
    </footer>
  );
}
